import { render, staticRenderFns } from "./DarkThemeSwitch.vue?vue&type=template&id=75700ad5&"
import script from "./DarkThemeSwitch.vue?vue&type=script&lang=js&"
export * from "./DarkThemeSwitch.vue?vue&type=script&lang=js&"
import style0 from "./DarkThemeSwitch.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports